import Breadcrumb from "components/Breadcrumb/Breadcrumb"
import SwitchOptionTable from "components/OptionsTable/SwitchOptionTable"
import NewStaticTable from "components/staticTable/NewStaticTable"
import { paginationType } from "global/Interfaces/Interfaces"
import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getDay } from "tools/functions/Methods"

import { MdOutlineRemoveRedEye } from "react-icons/md"
import DeleteOperation from "components/tableOperation/DeleteOperation"
import { AiOutlineEdit } from "react-icons/ai"
import { filterSharePercent } from "redux/share-percent"
import SearchForm from "./Search"
import SharePercentFrom from "./views/share-percent-form"
import { SharePercentColumn } from "./Columns"
import { createParams } from "./utils"
import { hasPermission } from "utils/HasPermission"

const SharePercent = () => {
  const dispatch = useDispatch()

  const { filter, sharePercent, fetchpost } = useSelector(
    (state: any) => state.SharePercentSlice
  )
  const { pageNumbers } = useSelector((state: paginationType) => state.paginate)
  const [isActive, setIsACtive] = useState(true)
  const [selectedRow, setSelectedRow] = useState<any>([])
  const [isView, setIsView] = useState<boolean>(false)
  const [currentData, setCurrentData] = useState<any>()

  const [openModal, setOpenModal] = useState({
    sharePercentModal: false,
  })

  const refreshTable = () => {
    dispatch(
      filterSharePercent({
        ...filter,
        pageSize: 10,
        pageNumber: pageNumbers,
      }) as any
    )
    setSelectedRow([])
  }

  let data =
    sharePercent?.content?.length !== 0
      ? sharePercent?.content?.map((item: any) => {
          return {
            ...item,
            id: item.consignment?.id,
            type: item.type.text,
            hub: item.hub?.text,
            validFrom: !!item.validFrom && getDay(item.validFrom),
            validTo: !!item.validTo && getDay(item.validTo),
            isActive: item.isActive ? "فعال" : "غیرفعال",
            operation: (
              <div className="flex w-full gap-3 justify-center">
                  <button
                    className=" border-none	 text-[14px]  w-[20px] h-[20px] "
                    onClick={() => {
                      setIsView(true)
                      setCurrentData(item)
                      setOpenModal({ ...openModal, sharePercentModal: true })
                    }}
                  >
                    <MdOutlineRemoveRedEye className="w-full h-full" />
                  </button>
         
                {hasPermission("edit_sahare_percentage") && item.isActive && (
                  <button
                    className=" border-none	 text-[14px]  w-[20px] h-[20px] "
                    onClick={() => {
                      setCurrentData(item)
                      setOpenModal({ ...openModal, sharePercentModal: true })
                    }}
                  >
                    <AiOutlineEdit className="w-full h-full" />
                  </button>
                )}
                {hasPermission("delete_sahare_percentage") && (
                  <DeleteOperation
                    title={"حذف "}
                    handleDeleteActionNewData={refreshTable}
                    route={`/core-api/sharePercentage/v2?${createParams(item)}`}
                  />
                )}
              </div>
            ),
          }
        })
      : []

  return (
    <>
      <Breadcrumb curentPage="حق السهم" beforePage="مدیریت هاب" />

      <SearchForm isActive={isActive} />
      <SwitchOptionTable
        accessPage={[
          {
            code: "A24",
            value: () =>
              setOpenModal({ ...openModal, sharePercentModal: true }),
            permission: hasPermission("add_sahare_percentage"),
          },

          {
            code: "A3",
            value: { data: isActive, action: () => setIsACtive(!isActive) },
          },
          {
            code: "A1",
            value: {
              data: data,
              columns: SharePercentColumn,
              title: "sharePercent",
            },
          },
        ]}
        // selectedState={selectedRow}
      />
      <NewStaticTable
        data={data ? data : []}
        THWrapper={"whitespace-nowrap"}
        pagination={sharePercent?.totalElements}
        setselectedState={(value) => {
          const isPayed = value.filter(
            (item: any) => item.payStatusRaw?.id !== 1
          )
          setSelectedRow(isPayed)
        }}
        selectedState={selectedRow}
        column={SharePercentColumn}
        loading={fetchpost}
        ignoreRedux={true}
      />

      {openModal.sharePercentModal && (
        <SharePercentFrom
          open={openModal.sharePercentModal}
          setOpen={setOpenModal}
          isView={isView}
          currentData={currentData}
          refreshTable={refreshTable}
          onClose={() => {
            setCurrentData({})
            setIsView(false)
            setOpenModal({ sharePercentModal: false })
          }}
        />
      )}
    </>
  )
}

export default SharePercent
